import React from "react";
import { TextField, Stack, IconButton, InputAdornment } from "@mui/material";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import SendIcon from "@mui/icons-material/Send";
import MessageData from "../data/MessageData";
import AudioCaptureModal from "./AudioCaptureModal";
import useEvents from "../hooks/useEvents";

const SendMessage = (props) => {
  const [message, setMessage] = React.useState(
    localStorage.getItem(`draftMessage-${props.groupId}`) || "",
  );
  const [audioOpen, setAudioOpen] = React.useState(false);
  const events = useEvents();

  React.useEffect(() => {
    setMessage(localStorage.getItem(`draftMessage-${props.groupId}`) || "");
  }, [props.groupId]);

  async function sendTheMessage() {
    if (message.length > 0 && props.groupId) {
      await MessageData.sendMessageToGroup(props.groupId, message);
      setMessage("");
    }
    localStorage.removeItem(`draftMessage-${props.groupId}`);
  }

  async function sendTheAudioMessage(blob, buffer, duration) {
    if (blob) {
      await MessageData.sendAudioMessageToGroup(props.groupId, blob, buffer, duration);
      setMessage("");
    }
  }

  return (
    <>
      <Stack
        direction="row"
        sx={{
          px: 2,
          alignItems: "center",
          gap: 1,
        }}
      >
        <TextField
          size="small"
          placeholder="Type a message"
          fullWidth
          multiline
          maxRows={3}
          variant="outlined"
          value={message}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  color="primary"
                  size="small"
                  onClick={() => {
                    setAudioOpen(true);
                  }}
                >
                  <KeyboardVoiceIcon />
                </IconButton>
              </InputAdornment>
            ),
            sx: {
              borderRadius: 4,
              fontSize: "0.95rem",
            },
          }}
          onKeyDown={(e) => {
            if (e.keyCode === 13 && !e.shiftKey) {
              e.preventDefault();
              sendTheMessage();
            }
          }}
          onChange={(event) => {
            localStorage.setItem(
              `draftMessage-${props.groupId}`,
              event.target.value,
            );
            setMessage(event.target.value);
          }}
        />

        <IconButton
          color="primary"
          sx={{
            bgcolor: "primary.main",
            color: "white",
            "&:hover": {
              bgcolor: "primary.dark",
            },
            width: 40,
            height: 40,
          }}
          onClick={() => {
            events.logButtonClick({
              buttonName: "Send Message",
              pageName: "Messages",
              tabName: props.groupId,
            });
            sendTheMessage();
            const logEvent = {
              clientId: props.uid,
              groupId: props.groupId,
            };
            events.logButtonClick(logEvent);
          }}
          disabled={message.trim() === ""}
        >
          <SendIcon />
        </IconButton>
      </Stack>

      {audioOpen && (
        <AudioCaptureModal
          open={audioOpen}
          onDialogClosed={(blob, buffer, duration) => {
            if (blob) {
              sendTheAudioMessage(blob, buffer, duration);
            }
            setAudioOpen(false);
          }}
          onError={() => {
            //
          }}
        />
      )}
    </>
  );
};

export default SendMessage;
